<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <links-panel/>
    </div>
    <router-view/>
  </div>
</template>
<script>
  import LinksPanel from './LinksPanel'

  export default {
    components: {
      linksPanel: LinksPanel
    }
  }
</script>
